import { BaseRequestModel } from '../../../base/base.request.model';

export class GetEntitlementsRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetEntitlementsRequestMessage!: GetEntitlementsRequestModel;
}

class GetEntitlementsRequestModel extends BaseRequestModel {
  contactID!: string;
  returnProductAttributes!: boolean;
  returnUpgradableFlag!: boolean;
}
